import React, { createContext, useState, useEffect } from "react";
import i18n from "../Helper/i18n";
// import RTL from;

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [isRTL, setIsRTL] = useState(false);

  const setLanguage = (language) => {
    i18n.changeLanguage(language);
    document.documentElement.lang = language;
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
    setIsRTL(language === "ar");
    localStorage.setItem("i18nextLng", language);
    if (language === "ar") {
      addRTLStyles();
    } else {
      removeRTLStyles();
    }
  };
  const addRTLStyles = () => {
    if (!document.getElementById("rtl-styles")) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "/rtl.css";
      link.id = "rtl-styles";
      document.head.appendChild(link);
    }
  };

  // ✅ Remove RTL CSS
  const removeRTLStyles = () => {
    const rtlLink = document.getElementById("rtl-styles");
    if (rtlLink) {
      rtlLink.parentNode.removeChild(rtlLink);
    }
  };

  useEffect(() => {
    const savedLang = localStorage.getItem("i18nextLng") || "en";
    setLanguage(savedLang);
  }, []);

  return (
    <LanguageContext.Provider value={{ isRTL, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
